module.exports = "/_next/static/images/partner-lazada-37c032e6650b863893c42b812ece6975.png";